import React, { useState } from 'react';
import { Mutation } from '@apollo/client/react/components';
import { Android, Cancel } from '@material-ui/icons';
import {
  IconButton,
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
} from '@material-ui/core';
import { TRY_AGAIN_CONTENT_GENERATOR } from 'queries/titleContent';
import { Toast } from 'components/Toast';

interface IContentGeneratorProps {
  selectedTitles: Map<string, ITitle>;
  refetch: () => void;
}

const ContentGenerator: React.FC<IContentGeneratorProps> = ({
  selectedTitles,
  refetch,
}) => {
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [multiple, setMultiple] = useState(false);

  const handleCloseConfirmation = () => {
    setOpenConfirmation(false);
  };

  const checkPremise = (titles: Map<string, ITitle>) => {
    const titlesWithoutPremise: string[] = [];
    titles.forEach((title) => {
      if (!title.premise) {
        titlesWithoutPremise.push(title.title);
      }
    });
    return titlesWithoutPremise;
  };

  const handleOpenConfirmation = () => {
    const titlesWithoutPremise = checkPremise(selectedTitles);

    if (titlesWithoutPremise.length === selectedTitles.size) {
      Toast(
        `Cannot try again: ${titlesWithoutPremise.length} title(s) without premise`,
        'warning',
      );
      return;
    }

    if (selectedTitles.size > 1) {
      setMultiple(true);
    } else {
      setMultiple(false);
    }
    setOpenConfirmation(true);
  };

  return (
    <Mutation
      mutation={TRY_AGAIN_CONTENT_GENERATOR}
      update={async () => {
        await refetch();
      }}
    >
      {(tryAgainContentGenerator: any) => (
        <div>
          <Tooltip title="Content Generator">
            <IconButton
              color="primary"
              aria-label="content generator"
              onClick={(e) => {
                e.preventDefault();
                handleOpenConfirmation();
              }}
            >
              <Android />
            </IconButton>
          </Tooltip>
          <Dialog
            open={openConfirmation}
            onClose={handleCloseConfirmation}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">Are you sure?</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {multiple
                  ? 'Do you really want to regenerate content for these Titles?'
                  : 'Do you really want to regenerate content for this Title?'}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseConfirmation} color="default">
                <Cancel />
                &nbsp; Cancel
              </Button>
              <Button
                onClick={async () => {
                  const ids = Array.from(selectedTitles.values())
                    .filter((title) => title.premise)
                    .map((title) => title.id);

                  try {
                    await tryAgainContentGenerator({ variables: { ids } });
                    Toast(
                      'Content regeneration started successfully!',
                      'success',
                    );
                  } catch (error) {
                    Toast('Failed to start content regeneration', 'error');
                  }
                  setOpenConfirmation(false);
                }}
                color="primary"
                autoFocus
              >
                <Android />
                &nbsp; Generate
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </Mutation>
  );
};

export default ContentGenerator;
